module.exports = __webpack_public_path__ + "static/media/project-img5.cc8b9488.png";